/** The two FSRS states that live in the short-term learning steps. */
function isLearningState(state) {
    return state === "LEARNING" || state === "RELEARNING";
}
/** Mirrors the `due` filter in the server's queue counts: a review-stage card whose due date has passed. */
function isDueReview(card, now) {
    return (card.state === "REVIEW" || card.state === "RELEARNING") && new Date(card.due).getTime() <= now.getTime();
}
/**
 * Advance the study-page counters after one review the server accepted.
 *
 * The queue endpoint computes these numbers once per batch; refetching it mid-session
 * would reset the learner's position, so the client replays the same rules locally:
 *
 * - `new` and `newRemainingToday` drop the moment a NEW card is answered, which is when
 *   the server's `countTodaysWork` counts it as introduced.
 * - `reviewRemainingToday` drops on every answer whose previous state was REVIEW or
 *   RELEARNING, exactly like the server's `reviews_done` filter -- including a
 *   relearning card re-shown by the 1-minute step.
 * - `due` only drops the first time a due card is answered in this session. A card that
 *   comes back through the learning steps was already subtracted, so it must not be
 *   subtracted again when it is re-answered.
 * - `learning` follows cards entering or leaving the short-term steps.
 *
 * Nothing goes below zero: the daily allowances are reported clamped by the server too.
 */
export function applyReviewToCounts(counts, before, after, now, firstAnswerThisSession) {
    const wasNew = before.state === "NEW";
    const wasReviewStage = before.state === "REVIEW" || before.state === "RELEARNING";
    const leftDuePool = firstAnswerThisSession && isDueReview(before, now);
    const learningDelta = Number(isLearningState(after.state)) - Number(isLearningState(before.state));
    return {
        due: Math.max(0, counts.due - (leftDuePool ? 1 : 0)),
        new: Math.max(0, counts.new - (wasNew ? 1 : 0)),
        learning: Math.max(0, counts.learning + learningDelta),
        newRemainingToday: Math.max(0, counts.newRemainingToday - (wasNew ? 1 : 0)),
        reviewRemainingToday: Math.max(0, counts.reviewRemainingToday - (wasReviewStage ? 1 : 0))
    };
}
//# sourceMappingURL=studyCounts.js.map